// Main page for building a distinct landing page
import "./index.css";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import Landing from "./pages/landing";

if (import.meta.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(<Landing />);
